<template>
  <PopUp
    :model-value="isOpen"
    size="md"
    :scrollable="true"
    :show-close-button="true"
    @update:model-value="v => !v && emit('close')"
    @close="emit('close')"
  >
    <div class="p-8">
      <Transition name="step-slide" mode="out-in">
        <!-- SUCCESS -->
        <div
          v-if="currentStep === STEP_SUCCESS"
          key="success"
          class="text-center py-6"
        >
          <div
            class="w-12 h-12 rounded-full bg-[#2d7a6a]/10 flex items-center justify-center mx-auto mb-4"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2d7a6a"
              stroke-width="2.5"
              stroke-linecap="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 class="text-[2rem] font-bold mb-2 text-[#0f1f2e]">
            {{ successTitle }}
          </h2>
          <p class="text-[1.4rem] text-[#627282]">{{ successMessage }}</p>

          <!-- Session created: action list -->
          <div
            class="mt-6 flex flex-col divide-y divide-black/[0.06] border border-black/[0.08] rounded-2xl overflow-hidden text-left"
          >
            <button
              class="flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#25d366]"
              @click="emit('share-whatsapp')"
            >
              <span
                class="w-8 h-8 rounded-full bg-[#25d366]/10 flex items-center justify-center flex-shrink-0"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#25d366">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.852L0 24l6.335-1.502A11.936 11.936 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.89 0-3.663-.497-5.2-1.369l-.373-.214-3.762.892.952-3.67-.235-.387A9.937 9.937 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                </svg>
              </span>
              {{ t("shareWhatsApp") }}
            </button>
            <button
              class="flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#229ed9]"
              @click="emit('share-telegram')"
            >
              <span
                class="w-8 h-8 rounded-full bg-[#229ed9]/10 flex items-center justify-center flex-shrink-0"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#229ed9">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.17 13.4l-2.945-.924c-.64-.203-.653-.64.136-.953l11.57-4.461c.537-.194 1.006.131.963.159z"/>
                </svg>
              </span>
              {{ t("shareTelegram") }}
            </button>
            <button
              class="flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] font-semibold text-[#0f1f2e]"
              @click="emit('copy-info')"
            >
              <span
                class="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" />
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                </svg>
              </span>
              {{ sessionInfoCopied ? t("copied") : t("shareCopy") }}
            </button>
            <button
              class="flex items-center gap-3 px-5 py-4 hover:bg-slate-50 transition text-[1.4rem] text-[#627282]"
              @click="emit('close')"
            >
              <span
                class="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center flex-shrink-0"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </span>
              {{ t("close") }}
            </button>
          </div>
        </div>

        <!-- PROPOSE SESSION form -->
        <div v-else key="propose">
          <h2 class="text-[2rem] font-bold mb-1 text-[#0f1f2e]">
            {{ t("proposeSession") }}
          </h2>
          <p class="text-[1.4rem] text-[#627282] mb-6">{{ groupName }}</p>

          <div class="space-y-5">
            <!-- Day picker -->
            <div>
              <label class="block text-[1.4rem] font-bold text-black mb-[0.8rem]">
                {{ t("sessionDate") }}
              </label>
              <div
                class="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1"
                style="scrollbar-width: none"
              >
                <button
                  v-for="day in proposalDays"
                  :key="day.iso"
                  type="button"
                  class="flex-shrink-0 flex flex-col items-center w-[4.8rem] py-[0.8rem] rounded-xl border transition select-none"
                  :class="
                    proposalDate === day.iso
                      ? 'bg-[#0f1f2e] text-white border-[#0f1f2e]'
                      : 'bg-white text-[#0f1f2e] border-black/15 hover:border-black/30 active:bg-slate-50'
                  "
                  @click="emit('select-day', day.iso)"
                >
                  <span
                    class="text-[1.05rem] leading-none mb-[0.3rem]"
                    :class="proposalDate === day.iso ? 'opacity-80' : 'text-[#627282]'"
                  >{{ day.weekday }}</span>
                  <span
                    class="text-[1.5rem] font-bold leading-none"
                    :class="proposalDate === day.iso ? '' : day.isToday ? 'text-[#2d7a6a]' : ''"
                  >{{ day.num }}</span>
                  <span
                    v-if="day.showMonth"
                    class="text-[0.95rem] leading-none mt-[0.25rem]"
                    :class="proposalDate === day.iso ? 'opacity-70' : 'text-[#9ab4c0]'"
                  >{{ day.month }}</span>
                </button>
              </div>
            </div>

            <!-- Time picker -->
            <div v-if="proposalDate">
              <label class="block text-[1.4rem] font-bold text-black mb-[0.8rem]">
                {{ t("sessionTime") }}
              </label>
              <div class="grid grid-cols-4 gap-[0.6rem]">
                <button
                  v-for="slot in availableTimeSlots"
                  :key="slot.value"
                  type="button"
                  class="py-[0.8rem] rounded-xl border text-[1.3rem] font-medium transition text-center select-none"
                  :class="
                    proposalTime === slot.value
                      ? 'bg-[#0f1f2e] text-white border-[#0f1f2e]'
                      : 'bg-white text-[#0f1f2e] border-black/15 hover:border-black/30 active:bg-slate-50'
                  "
                  @click="emit('update:proposalTime', slot.value)"
                >
                  {{ slot.label }}
                </button>
              </div>
              <p v-if="availableTimeSlots.length === 0" class="text-[1.3rem] text-[#9ab4c0] mt-2">
                {{ t("noTimeSlotsToday") }}
              </p>
            </div>

            <div>
              <label class="block text-[1.4rem] font-bold text-black mb-[0.8rem]">
                {{ t("sessionDescriptionLabel") }}
                <span class="font-normal ml-1 text-[#9ab4c0]">{{ t("optional") }}</span>
              </label>
              <textarea
                :value="proposalDescription"
                rows="3"
                class="textarea border-black/15 focus:border-black/30 h-auto min-h-[10rem]"
                :placeholder="t('sessionDescriptionPlaceholder')"
                @input="emit('update:proposalDescription', ($event.target as HTMLTextAreaElement).value)"
              />
            </div>

            <div>
              <label class="block text-[1.4rem] font-bold text-black mb-[0.8rem]">
                {{ t("maxAttendees") }}
                <span class="font-normal ml-1 text-[#9ab4c0]">{{ t("optional") }}</span>
              </label>
              <input
                :value="proposalMaxAttendees"
                type="number"
                min="2"
                max="500"
                class="input border-black/15 focus:border-black/30"
                :placeholder="t('maxAttendeesPlaceholder')"
                @input="emit(
                  'update:proposalMaxAttendees',
                  ($event.target as HTMLInputElement).value === ''
                    ? null
                    : Number(($event.target as HTMLInputElement).value),
                )"
              />
            </div>
          </div>

          <p v-if="submitError" class="text-[1.3rem] text-red-500 mt-4">
            {{ submitError }}
          </p>
          <div class="flex justify-end mt-6">
            <button
              class="px-[3.2rem] py-[1.2rem] rounded-[10rem] bg-[#0f1f2e] text-white text-[1.4rem] font-semibold disabled:opacity-40 transition hover:opacity-85"
              :disabled="!proposalDate || !proposalTime || isSubmitting"
              @click="emit('submit')"
            >
              {{ t("confirmPropose") }}
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </PopUp>
</template>

<script setup lang="ts">
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";

const props = defineProps<{
  isOpen: boolean;
  currentStep: number;
  groupName: string;
  proposalDate: string;
  proposalDays: Array<{
    iso: string;
    weekday: string;
    num: number;
    month: string;
    showMonth: boolean;
    isToday: boolean;
  }>;
  availableTimeSlots: Array<{ value: string; label: string }>;
  proposalTime: string;
  proposalDescription: string;
  proposalMaxAttendees: number | "" | null;
  isSubmitting: boolean;
  submitError: string;
  successTitle: string;
  successMessage: string;
  successMode: string;
  sessionInfoCopied: boolean;
}>();

const STEP_SUCCESS = 99;

const emit = defineEmits<{
  (e: "close"): void;
  (e: "select-day", iso: string): void;
  (e: "update:proposalTime", value: string): void;
  (e: "update:proposalDescription", value: string): void;
  (e: "update:proposalMaxAttendees", value: number | null): void;
  (e: "submit"): void;
  (e: "share-whatsapp"): void;
  (e: "share-telegram"): void;
  (e: "copy-info"): void;
}>();

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);
</script>

<style scoped>
.step-slide-enter-active,
.step-slide-leave-active {
  transition: all 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}
.step-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.step-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
